// extracted by mini-css-extract-plugin
export default {"componentWrapper":"Status_componentWrapper__7QTcL","message":"Status_message__DBvrL"};